import axios from "axios";
// Class
import PackageCompositionItem from "../classes/PackageCompositionItem";

const getPackageComposition = async (storeObj: any): Promise<void> => {
	const { state } = storeObj;
	console.log("state: ", state);
	const {
		liheData: { id },
		dates: { BeginDate, EndDate },
		packageId,
	} = state;

	const formattedStartDate = formatDate(BeginDate);
	const formattedEndDate = formatDate(EndDate);

	const response = await axios.get(
		"https://api-migdal.travelfactory.fr/cms/package-composition",
		{
			params: {
				liheId: id,
				startDate: formattedStartDate,
				endDate: formattedEndDate,
				prestId: packageId,
			},
		}
	);

	const data: Array<PackageCompositionItem> = response.data;
	const packageCompositionMap: Map<string, string> = new Map(
		data.map((item) => [item.serviceFamily, item.duration])
	);
	state.packageComposition = packageCompositionMap;
};

function formatDate(date: string): string {
	if (!date) throw new Error("date is mandatory in formatDate");
	return date.split("/").reverse().join("-");
}

export default getPackageComposition;
